import { createClient } from "@supabase/supabase-js";
import * as Sentry from "@sentry/react";

const url = __SUPABASE_URL__;
const anon = __VITE_SUPABASE_ANON_KEY__;

if (!url || !anon) {
  throw new Error("SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set in env");
}

export const supabase = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

// Tie Sentry events to the signed-in user (id only, no PII) so issues are
// attributable. Safe no-op when Sentry is not initialized (no DSN).
supabase.auth.onAuthStateChange((_event, session) => {
  Sentry.setUser(session?.user ? { id: session.user.id } : null);
});
